"use strict";

document.addEventListener("DOMContentLoaded", function () {
  if (document.querySelector('body.page-template-bounce-back')) {
    var startAnimation = function startAnimation() {
      var height = document.querySelector('.bounce-back__box').offsetHeight;
      var animHeight = height * 0.44;
      anime({
        targets: '.bounce-back__circle',
        duration: 2000,
        keyframes: [{
          width: '25%',
          height: '44%',
          translateY: animHeight,
          easing: 'cubicBezier(0.175, 0.885, 0.735, 1.650)',
          duration: 500
        }, {
          width: '90%',
          height: '161%',
          translateY: -(height * 1.61 / 2 - height / 2)
        }],
        complete: function complete(anim) {
          animateText();
        }
      });
      function animateText() {
        anime({
          targets: '.bounce-back__text',
          marginTop: 0,
          opacity: '1',
          easing: 'linear',
          duration: 500,
          complete: function complete(anim) {
            bounce();
          }
        });
        function bounce() {
          anime({
            targets: '.bounce-back__title > span',
            translateY: anime.stagger([-5, -20]),
            delay: anime.stagger([50, 150]),
            direction: 'alternate',
            easing: 'easeInOutQuad',
            duration: 300
          });
        }
      }
    };
    setTimeout(function () {
      startAnimation();
    }, 500);
  }
});